// src/components/admin/blockEditors/StatsBlockEditor.tsx - VERSÃO COM ÍCONES

import React, { useState, useEffect } from 'react';
import { Plus, Trash2, Package, BookOpen, Clock, Target } from 'lucide-react';
import { StatsBlock, StatItem } from '../../../types/contentBlocks.types';
import './BlockEditors.css';

interface StatsBlockEditorProps {
    block: StatsBlock;
    onChange: (block: StatsBlock) => void;
}

// ✅ ÍCONES LUCIDE DISPONÍVEIS
const AVAILABLE_ICONS = [
    { value: 'package', label: 'Package', Icon: Package },
    { value: 'book', label: 'Livro', Icon: BookOpen },
    { value: 'clock', label: 'Relógio', Icon: Clock },
    { value: 'target', label: 'Alvo', Icon: Target }
];

export const StatsBlockEditor: React.FC<StatsBlockEditorProps> = ({ block, onChange }) => {
    const [items, setItems] = useState<StatItem[]>(block.data.items);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            onChange({
                ...block,
                data: { items }
            });
        }, 500);

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);

    const addItem = () => {
        setItems([...items, { label: 'Nova Estatística', value: '0', icon: 'package' }]);
    };

    const updateItem = (index: number, field: keyof StatItem, value: string | number) => {
        const newItems = [...items];
        newItems[index] = { ...newItems[index], [field]: value };
        setItems(newItems);
    };

    const removeItem = (index: number) => {
        if (items.length > 1) {
            setItems(items.filter((_, i) => i !== index));
        }
    };

    return (
        <div className="be-container">
            <div className="be-stats-list">
                {items.map((item, index) => {
                    return (
                        <div key={index} className="be-stat-item">
                            <div className="be-stat-header">
                                <span className="be-stat-number">#{index + 1}</span>
                                {items.length > 1 && (
                                    <button
                                        className="be-btn-remove"
                                        onClick={() => removeItem(index)}
                                        title="Remover"
                                    >
                                        <Trash2 size={16} />
                                    </button>
                                )}
                            </div>

                            {/* ✅ NOVA ESTRUTURA */}
                            <div className="be-form-group">
                                <label className="be-label">Ícone</label>
                                <div className="be-icon-selector">
                                    {AVAILABLE_ICONS.map(({ value, Icon }) => (
                                        <button
                                            key={value}
                                            type="button"
                                            className={`be-icon-option ${item.icon === value ? 'selected' : ''}`}
                                            onClick={() => updateItem(index, 'icon', value)}
                                            title={value}
                                        >
                                            <Icon size={20} />
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="be-form-group">
                                <label className="be-label">Valor</label>
                                <input
                                    type="text"
                                    className="be-input"
                                    value={item.value}
                                    onChange={(e) => updateItem(index, 'value', e.target.value)}
                                    placeholder="Ex: 1200"
                                />
                            </div>

                            <div className="be-form-group">
                                <label className="be-label">Descrição</label>
                                <input
                                    type="text"
                                    className="be-input"
                                    value={item.label}
                                    onChange={(e) => updateItem(index, 'label', e.target.value)}
                                    placeholder="Ex: Total de Flashcards"
                                />
                            </div>
                        </div>
                    );
                })}
            </div>

            <button className="be-btn-add" onClick={addItem}>
                <Plus size={18} />
                Adicionar Estatística
            </button>
        </div>
    );
};